import getLocale from 'config/localServer/query/getLocale'
import { useQuery } from 'components/graphql'

export default () => {
	const { data: { getLocale: locales } } = useQuery(getLocale)
	// only undefined is valid value to use default locale in native convertors toLocaleString
	// eslint-disable-next-line no-undefined
	return locales || undefined
}
